"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _url = require("url");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _debug = _interopRequireDefault(require("debug"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _Toggle = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Toggle"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _ErrorBoundary = _interopRequireDefault(require("../ErrorBoundary"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm7-2a1 1 0 0 1 1-1h1a2 2 0 0 1 2 2v4h1a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h1v-4h-1a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
  }));
};
InfoIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "actions": "APIRequestPanel__actions__1W2Hq",
  "action": "APIRequestPanel__action__3WPQ4",
  "label": "APIRequestPanel__label__2eCwz",
  "disabled": "APIRequestPanel__disabled__32ERy",
  "api-instance": "APIRequestPanel__api-instance__Pt8_9",
  "apiInstance": "APIRequestPanel__api-instance__Pt8_9",
  "title": "APIRequestPanel__title__3Y8JZ",
  "method-display-name": "APIRequestPanel__method-display-name__3mT7w",
  "methodDisplayName": "APIRequestPanel__method-display-name__3mT7w",
  "method-name": "APIRequestPanel__method-name__3RXgq",
  "methodName": "APIRequestPanel__method-name__3RXgq",
  "post": "APIRequestPanel__post__3smc3",
  "put": "APIRequestPanel__put__334rh",
  "get": "APIRequestPanel__get__3zMwg",
  "patch": "APIRequestPanel__patch__SCqDi",
  "delete": "APIRequestPanel__delete__nA-Xu",
  "options": "APIRequestPanel__options__12Ttn",
  "head": "APIRequestPanel__head__2pels",
  "firewall-section": "APIRequestPanel__firewall-section__1n6vq",
  "firewallSection": "APIRequestPanel__firewall-section__1n6vq",
  "toggle-container": "APIRequestPanel__toggle-container__3OXNy",
  "toggleContainer": "APIRequestPanel__toggle-container__3OXNy",
  "toggle": "APIRequestPanel__toggle__2sJlj"
}; 
require('./APIRequestPanel.css');
var log = (0, _debug.default)('apiconsole:components:apirequestpanel');
var APIRequestPanel = exports.default = /*#__PURE__*/function (_React$Component) {
  function APIRequestPanel(props, context) {
    var _this;
    (0, _classCallCheck2.default)(this, APIRequestPanel);
    _this = _callSuper(this, APIRequestPanel, [props, context]);
    (0, _defineProperty2.default)(_this, "updateAPIBehindFirewallState", function () {
      _this.setState({
        isAPIBehindFirewall: _this.props.apiFirewallEnabled
      });
    });
    (0, _defineProperty2.default)(_this, "initializeServerSelector", function () {
      _this.updateSelectedServer(_this.getMockingServiceInstanceURI());
      _this.setState({
        selectedURL: _this.getMockingServiceInstanceURI()
      });
      _this.isServerSelectorInitialized = true;
    });
    (0, _defineProperty2.default)(_this, "handleAPIRequestDataChanged", function (_ref) {
      var detail = _ref.detail;
      _this.setState({
        selectedURL: detail.value
      });
    });
    (0, _defineProperty2.default)(_this, "handleAPIServerChanged", function (_ref2) {
      var detail = _ref2.detail;
      var onServerSelectorChanged = _this.props.onServerSelectorChanged;
      var type = detail.type,
        value = detail.value;
      _this.updateSelectedServer(value, type);
      if (_this.isServerSelectorInitialized) {
        onServerSelectorChanged(value, type);
      }
    });
    (0, _defineProperty2.default)(_this, "updateSelectedServer", function (value) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'uri';
      _this.requestPanel.baseUri = value;
      _this.requestPanel.serverValue = value;
      _this.requestPanel.serverType = type;
      _this.setState({
        serverValue: value,
        serverType: type
      });
    });
    (0, _defineProperty2.default)(_this, "isMockingServiceURI", function (uri) {
      var mockingServiceURI = _this.getMockingServiceInstanceURI();
      return !!uri && uri.startsWith(mockingServiceURI);
    });
    (0, _defineProperty2.default)(_this, "getAPIFirewallEnabled", function () {
      var apiFirewallEnabled = _this.props.apiFirewallEnabled;
      return apiFirewallEnabled || false;
    });
    (0, _defineProperty2.default)(_this, "saveAPISetting", function (value) {
      var onSaveAPIFirewallSettings = _this.props.onSaveAPIFirewallSettings;
      onSaveAPIFirewallSettings(value);
    });
    (0, _defineProperty2.default)(_this, "handleAPIConsoleRequest", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(requestEvent) {
        var _this$state, selectedURL, isAPIBehindFirewall, serverType, serverValue, isMockingServiceInstance;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$state = _this.state, selectedURL = _this$state.selectedURL, isAPIBehindFirewall = _this$state.isAPIBehindFirewall, serverType = _this$state.serverType, serverValue = _this$state.serverValue;
              isMockingServiceInstance = _this.isMockingServiceURI(selectedURL);
              log('api-request event', requestEvent);
              requestEvent.preventDefault();
              requestEvent.stopPropagation();
              _this.props.onAPIConsoleRequest({
                request: requestEvent.detail,
                isMockingServiceInstance: isMockingServiceInstance,
                isAPIBehindFirewall: isAPIBehindFirewall,
                serverValue: serverValue,
                serverType: serverType
              });
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)(_this, "handleOAuth2TokenRequest", function (event) {
      var config = _this.context;
      var isAPIBehindFirewall = _this.state.isAPIBehindFirewall;
      var _this$props = _this.props,
        organizationDomain = _this$props.organizationDomain,
        organizationId = _this$props.organizationId,
        authorization = _this$props.authorization;
      if (!isAPIBehindFirewall) {
        var _event$detail;
        var proxyURL = (0, _url.format)(_objectSpread(_objectSpread({}, config.platform.uri), config.apiPortals.apiConsole.proxy.uri));
        var headers = [];
        if (organizationId) {
          headers.push({
            name: 'ms-organization-id',
            value: organizationId
          });
        }
        if (authorization) {
          headers.push({
            name: 'ms-authorization',
            value: authorization
          });
        }

        // eslint-disable-next-line no-param-reassign
        event.detail.accessTokenUri = "".concat(proxyURL, "organizations/").concat(organizationDomain, "/").concat(event.detail.accessTokenUri);
        if ((_event$detail = event.detail) !== null && _event$detail !== void 0 && (_event$detail = _event$detail.customData) !== null && _event$detail !== void 0 && _event$detail.token) {
          // eslint-disable-next-line no-param-reassign
          event.detail.customData.token.headers = headers;
        }
      }
    });
    (0, _defineProperty2.default)(_this, "getAPIInstances", function () {
      var apiInstances = _this.props.apiInstances;
      return apiInstances.filter(function (apiInstance) {
        return apiInstance.endpointUri;
      });
    });
    (0, _defineProperty2.default)(_this, "getMockingServiceInstanceURI", function () {
      var mockingServiceInstance = _this.getAPIInstances().find(_this.isMockingServiceInstance);
      return !!mockingServiceInstance && mockingServiceInstance.endpointUri;
    });
    (0, _defineProperty2.default)(_this, "toggleFirewall", function () {
      return _this.setState(function (state) {
        return {
          isAPIBehindFirewall: !state.isAPIBehindFirewall
        };
      }, _this.saveSetting);
    });
    (0, _defineProperty2.default)(_this, "saveSetting", function () {
      var isAPIBehindFirewall = _this.state.isAPIBehindFirewall;
      _this.saveAPISetting(isAPIBehindFirewall);
    });
    _this.isServerSelectorInitialized = false;
    _this.redirectURI = (0, _url.format)(_objectSpread(_objectSpread({}, context.externalURI), {}, {
      pathname: "".concat(context.externalURI.pathname).concat(context.apiPortals.apiConsole.components.oauthPopupPath)
    }));

    // eslint-disable-next-line react/state-in-constructor
    _this.state = {
      isAPIBehindFirewall: _this.getAPIFirewallEnabled()
    };
    return _this;
  }
  (0, _inherits2.default)(APIRequestPanel, _React$Component);
  return (0, _createClass2.default)(APIRequestPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.requestPanel.addEventListener('api-request-data-changed', this.handleAPIRequestDataChanged);
      this.requestPanel.addEventListener('url-value-changed', this.handleAPIRequestDataChanged);
      this.requestPanel.addEventListener('urlvaluechange', this.handleAPIRequestDataChanged);
      this.requestPanel.addEventListener('oauth2-token-requested', this.handleOAuth2TokenRequest);
      this.requestPanel.addEventListener('api-request', this.handleAPIConsoleRequest);
      this.requestPanel.addEventListener('apiserverchanged', this.handleAPIServerChanged);
      if (this.props.amfModel) {
        this.requestPanel.amf = this.props.amfModel;
        this.requestPanel.amfModel = this.props.amfModel;
        this.requestPanel.selected = this.props.selected;
        this.initializeServerSelector();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.amfModel !== this.props.amfModel) {
        this.requestPanel.amf = this.props.amfModel;
        this.requestPanel.amfModel = this.props.amfModel;
      }
      if (!!this.props.amfModel && this.requestPanel.selected !== this.props.selected) {
        var oldSelectedValue = this.requestPanel.selected;
        this.requestPanel.selected = this.props.selected;
        if (!oldSelectedValue) {
          this.initializeServerSelector();
        }
      }
      if (prevProps.apiFirewallEnabled !== this.props.apiFirewallEnabled) {
        this.updateAPIBehindFirewallState();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.requestPanel.removeEventListener('oauth2-token-requested', this.handleOAuth2TokenRequest);
      this.requestPanel.removeEventListener('api-request', this.handleAPIConsoleRequest);
      this.requestPanel.removeEventListener('api-request-data-changed', this.handleAPIRequestDataChanged);
      this.requestPanel.removeEventListener('url-value-changed', this.handleAPIRequestDataChanged);
      this.requestPanel.removeEventListener('urlvaluechange', this.handleAPIRequestDataChanged);
      this.requestPanel.removeEventListener('apiserverchanged', this.handleAPIServerChanged);
    }
  }, {
    key: "isMockingServiceInstance",
    value: function isMockingServiceInstance(apiInstance) {
      return !!apiInstance && apiInstance.id === 'mocking-service';
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var isAPIBehindFirewall = this.state.isAPIBehindFirewall;
      var isAPIConsoleProxyEnabled = this.props.isAPIConsoleProxyEnabled;
      var apiInstances = this.getAPIInstances();
      return /*#__PURE__*/_react.default.createElement("section", {
        "aria-label": "API request panel"
      }, isAPIConsoleProxyEnabled ? /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": "firewall-section",
        className: styles.firewallSection
      }, /*#__PURE__*/_react.default.createElement("span", {
        "data-test-id": "message"
      }, "API is behind firewall", /*#__PURE__*/_react.default.createElement("a", {
        "aria-label": "Information about API behind firewall",
        target: "_blank",
        href: "https://docs.mulesoft.com/api-manager/1.x/accessing-your-api-behind-a-firewall",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        size: "xs"
      }, /*#__PURE__*/_react.default.createElement(InfoIcon, {
        "data-icon-id": "info"
      })))), /*#__PURE__*/_react.default.createElement("span", {
        className: styles.toggleContainer
      }, /*#__PURE__*/_react.default.createElement(_Toggle.default, {
        tabIndex: "0",
        id: "firewall-switch",
        testId: "firewall-switch",
        checked: isAPIBehindFirewall,
        onChange: this.toggleFirewall,
        className: styles.toggle,
        "aria-label": "API is behind firewall"
      }))) : null, isAPIConsoleProxyEnabled ? /*#__PURE__*/_react.default.createElement("hr", {
        "data-test-id": "separator"
      }) : null, /*#__PURE__*/_react.default.createElement(_ErrorBoundary.default, {
        message: "We can't load the API Console"
      }, /*#__PURE__*/_react.default.createElement("oauth1-authorization", null), /*#__PURE__*/_react.default.createElement("oauth2-authorization", null), /*#__PURE__*/_react.default.createElement("div", {
        className: "apic-container"
      }, /*#__PURE__*/_react.default.createElement("api-request-panel", {
        narrow: true,
        noDocs: true,
        noCustom: true,
        allowCustom: true,
        compatibility: true,
        noUrlEditor: true,
        urlLabel: true,
        ref: function ref(requestPanel) {
          _this2.requestPanel = requestPanel;
        },
        redirectUri: this.redirectURI
      }, apiInstances.map(function (_ref4) {
        var id = _ref4.id,
          displayName = _ref4.displayName,
          endpointUri = _ref4.endpointUri;
        return /*#__PURE__*/_react.default.createElement("anypoint-item", {
          key: id,
          slot: "custom-base-uri",
          value: endpointUri
        }, displayName);
      })))));
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(APIRequestPanel, "propTypes", {
  amfModel: _propTypes.default.array,
  apiInstances: _propTypes.default.array,
  isAPIConsoleProxyEnabled: _propTypes.default.bool,
  apiFirewallEnabled: _propTypes.default.bool,
  selected: _propTypes.default.string,
  onAPIConsoleRequest: _propTypes.default.func,
  onServerSelectorChanged: _propTypes.default.func,
  onSaveAPIFirewallSettings: _propTypes.default.func,
  organizationDomain: _propTypes.default.string,
  organizationId: _propTypes.default.string,
  authorization: _propTypes.default.string
});
(0, _defineProperty2.default)(APIRequestPanel, "defaultProps", {
  apiInstances: [],
  isAPIConsoleProxyEnabled: true
});
(0, _defineProperty2.default)(APIRequestPanel, "contextType", _exchangeReactHooks.ConfigContext);
//# sourceMappingURL=APIRequestPanel.js.map